export default __webpack_public_path__ + "static/media/Brochure.e1af8678.pdf";